import { defineComponent as _defineComponent } from 'vue'
import { HeadingDisplay, ChipContext } from '@warrenbrasil/nebraska-web';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { SectionError } from '@/modules/common/components/SectionError';

import { ITemplateHeaderData } from './types';

interface Props {
  isLoading?: boolean;
  hasError?: boolean;
  data: ITemplateHeaderData;
}

interface Emits {
  (e: 'on-retry'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateHeader',
  props: {
    isLoading: { type: Boolean, default: false },
    hasError: { type: Boolean, default: false },
    data: null
  },
  emits: ["on-retry"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {





const emitOnRetry = () => {
  emits('on-retry');
};

return { __sfc: true,emits, emitOnRetry, HeadingDisplay, ChipContext, HeadingDisplayLoader, SectionError }
}

})